export default __webpack_public_path__ + "static/contact-form-pattern-grey-985c2d7568978259f087193225684f42.png";